export function withoutEmpty(obj) {
  let clone = { ...obj }
  let dirty = false

  for (let key in clone) {
    if (clone[key] === '' || clone[key] == null) {
      delete clone[key]
      dirty = true
    }
  }

  return dirty ? clone : obj
}

export function withoutNulls(obj) {
  let clone = { ...obj }
  let dirty = false

  for (var key in clone) {
    if (clone[key] === null) {
      delete clone[key]
      dirty = true
    }
  }

  return dirty ? clone : obj
}

/**
 * When keys are found within both objects, are they equal?
 */
export function isEqualUnion(a, b) {
  if (!a || !b) {
    return true
  }

  for (var key in a) {
    if (key in b) {
      if (b[key] !== a[key]) {
        return false
      }
    }
  }

  return true
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/object.js